import { createAppTheme } from "./theme.base";
import { prodColors } from "./theme.tokens";

export const LightThemeWithResponsiveFontSizes = createAppTheme(
  "light",
  prodColors.light,
);

export const DarkThemeWithResponsiveFontSizes = createAppTheme(
  "dark",
  prodColors.dark,
);
